<template>
  <DashboardTemplate :navMenu="true">
    <div v-loading="loading">
      <div class="text-left pd-b-3">
        <h2 class="mg-less">แก้ไขผู้สอน</h2>
      </div>

      <div class="pd-b-3  out-box-image pd-x-4">
        <el-upload
          action="#"
          class="box-image-upload-profile"
          ref="upload"
          list-type="picture-card"
          :auto-upload="false"
          :on-change="uploadImage"
        >
          <div class="preview">
            <avatar
              :rounded="false"
              :username="instructor?instructor.nameTH:''"
              :src="instructor && typeof instructor.profileImg != 'undefined' && instructor.profileImg != ''?`${urlImage}${instructorId}/${instructor.profileImg}`:''"
              :size="160"
              class="set-img"
            ></avatar>
            <span  class="icon">
              <i class="fas fa-1x fa-camera"></i>
            </span>
          </div>
        </el-upload>
      </div>

      <div>
        <InstructorForm
          @updateInstructor="updateInstructor"
          :instructor="instructor"
          type="update"
        />
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import InstructorForm from "@/components/instructor/InstructorForm";
import { HTTP } from "@/service/axios.js";
import Avatar from "vue-avatar";

export default {
  components: {
    DashboardTemplate,
    InstructorForm,
    Avatar
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      instructorId: "",
      instructor: null,
      loading: true,
      showProfile: true,
      urlImage: process.env.VUE_APP_BASE_URL_IMAGE,
    };
  },
  mounted() {
    this.setParams();
    this.fetchInstructorById();
  },
  methods: {
    uploadImage(file) {
      this.loading = true;

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();

      formData.append("userId", this.instructorId);
      formData.append("img", file.raw);
      formData.append("delFile", this.instructor.profileImg);

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`update/profile/img`, formData, config)
        .then((res) => {
          if (res.data.success) {
            this.fetchInstructorById();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("uploadImage error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.instructorId != "undefined") {
          this.instructorId = this.routeParams.instructorId;
        }
      }
    },
    updateInstructor(data) {
      this.loading = true;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();
      formData.append("userId", this.instructorId);
      formData.append("email", data.email);
      formData.append("nameTH", data.nameTh);
      formData.append("surnameTH", data.lastNameTh);
      formData.append("nameEN", data.nameEn);
      formData.append("surnameEN", data.lastNameEn);
      formData.append("titleName", data.prefix);
      formData.append("countryCode", data.countryCode);
      formData.append("mobilephone", data.phoneNumber);
      formData.append("position", data.position);

      if (data.password) {
        formData.append("password", data.password);
      }
      

      let institution = {
        name: data.organization,
        address: data.address,
        postcode: data.postcode,
        subdistrict: data.subDistrict,
        district: data.district,
        province: data.province,
      };

      formData.append("institution", JSON.stringify(institution));

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`instructor`, formData, config)
        .then((res) => {

          if (res.data.success) {
            this.fetchInstructorById();
            this.$message({
              message: 'แก้ไขสำเร็จแล้ว',
              type: 'success'
            });
          } else {
            this.loading = false;
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          this.loading = false;
          console.log("updateInstructor error", e);
        });
    },
    fetchInstructorById() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`instructor/${this.instructorId}`)
        .then((res) => {

          if (res.data.success) {
            this.instructor = res.data.obj;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchInstructorById error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>
